import React, { useCallback, useEffect, useState } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import TransactionSelectInput from 'tennders-finance/cost-invoice/components/TransactionSelectInput'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import { get } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { FieldsetContainer, GInput } from 'tennders-common/form/components'
import GDatePicker from 'tennders-common/form/components/date'
import CustomerRef from 'tennders-finance/sales-invoice/components/multiple-sales-invoice/CustomerRef'
import InputLabeledContainer from 'tennders-common/form/components/new-inputs/InputLabeledContainer'
import TextArea from 'tennders-common/form/components/new-inputs/TextArea'
import CurrencyInput from 'tennders-common/form/components/new-inputs/CurrencyInput'
import useMultipleSalesInvoiceRow from 'tennders-finance/sales-invoice/hooks/useMultipleSalesInvoiceRow'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import PercentageInput from 'tennders-common/form/components/new-inputs/PercentageInput'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import IconDeleteRound from '../../../../../icons/icon-delete-round-f.svg'
import IconAddFilled from '../../../../../icons/icon-add-filled.svg'

type Props = {
            index: number,
            removeLine ?: (index: number) => void,
            companyId ?: number,
            initialErrors ?: Record<string, any>,
            errors ?: Record<string, any>,
            defaultVat ?: number|string,
            onFormChange ?: (index: number, form: Record<string, any>) => void,
            saved ?: boolean,
            keyIndex ?: number,
            selectedTransaction ?: TransactionType,
            reversedVat ?: boolean,
            disabled ?:boolean,
            editMode ?: boolean,
            isCreditNote ? : boolean,
            selectedPaymentTerm ?: any
            totalLines ?:number,
            initialCustomerRefs ?: Record<string, any>[],
}

const MultipleSalesInvoiceRow = (props: Props) => {
  const {
    index = 0,
    totalLines,
    editMode,
    removeLine,
    companyId,
    onFormChange,
    initialErrors,
    errors,
    defaultVat = '',
    keyIndex,
    disabled,
    selectedTransaction,
    isCreditNote,
    selectedPaymentTerm,
    initialCustomerRefs
  } = props

  const {
    transaction,
    onTransactionChange,
    onChange,
    form
  } = useMultipleSalesInvoiceRow({
    vatPercentage: defaultVat !== '' ? defaultVat as number : undefined,
    onFormChange,
    index: keyIndex,
    isCreditNote,
    initialErrors
  })
  const { t } = useTranslation()
  const [customerRefs, setCustomerRefs] = useState(initialCustomerRefs && initialCustomerRefs.length > 0 ? initialCustomerRefs : (form?.customerReferenceList || []))

  useEffect(() => {
    if (!isCreditNote && selectedTransaction && totalLines === 0 && selectedTransaction?.id !== form.transactionId) {
      onTransactionChange(selectedTransaction?.id).then(() => {
        console.info('onTransactionChange', selectedTransaction?.id)
      })
    }
  }, [selectedTransaction])

  const addCustomerRef = useCallback((refNo) => {
    onChange('customerReferenceNumber', '')
    setCustomerRefs((prevRefs) => [...prevRefs, refNo])
  }, [])

  const onRemoveRef = useCallback((index) => {
    setCustomerRefs((prevRefs) => prevRefs.filter((_, i) => i !== index))
  }, [])

  useEffect(() => {
    onChange('customerReferenceList', customerRefs)
  }, [customerRefs])

  useEffect(() => {
    // if (form.amount) {
    onChange('vatPercentage', defaultVat)
    // }
  }, [defaultVat])

  const removeCar = (index) => {
    const shipments = form.shipmentItems || []
    shipments.splice(index, 1)
    onChange('shipmentItems', shipments)
  }
  return (
    <>
      <div key={keyIndex}>
        <p className="text-uppercase d-flex align-center mb-10 ls-1">
          <strong>( {index + 1} ) {t('salesInvoice:serviceDescription')}</strong>
          {index > -1 ? (
            <GHref
              onClick={() => removeLine(index)}
              className="cursor-pointer d-flex align-center ml-8">
              <IconDeleteRound className="btn-only-icon" />
            </GHref>
          ) : null}
        </p>
        <div className="mt-10 pr-16">
          <span>{`${t('salesInvoice:route')}:`}<span className="bold">{form.route}</span></span>
        </div>
        <div className="d-flex row mb-16">
          <div className="w-30">
            <div className="mt-10 mr-10">
              <fieldset>
                <label htmlFor="" className="form-label">{t('salesInvoice:order_number')}</label>
                <TransactionSelectInput
                  disabled={isCreditNote || !companyId}
                  companyType="shipper"
                  transactionId={form?.transactionId}
                  selectedOptionLabel={form?.orderName}
                  companyId={companyId}
                  error={get(errors, '0.errors.transaction') && !get(transaction, 'referenceNumber') && get(errors, '0.errors.transaction')}
                  onTransactionChange={onTransactionChange}
                  showError
                />
              </fieldset>
            </div>
            <div className="mt-10 mr-10">
              <GInput
                className="smaller form-input w-100"
                form={form}
                errors={errors}
                onChange={onChange}
                name="clientName"
                label={t('salesInvoice:clientName')}
              />
            </div>
            <GDatePicker
              single
              className="smaller form-input w-100"
              eClass="mt-10 mr-10 pos-rel"
              readOnly={disabled}
              notClearable
              form={form}
              errors={errors}
              onChange={onChange}
              name="loadingDate"
              type="date"
              label={t('salesInvoice:loadingDate')}
            />
            <GDatePicker
              single
              className="smaller form-input w-100"
              eClass="mt-10 mr-10 pos-rel"
              readOnly={disabled}
              notClearable
              form={form}
              errors={errors}
              onChange={onChange}
              name="unloadingDate"
              type="date"
              label={t('salesInvoice:unloadingDate')}
            />
          </div>
          <div className="w-30">
            <GInput
              eClass="mt-10 mr-10"
              className="smaller form-input w-100"
              readOnly={disabled}
              form={form}
              errors={errors}
              onChange={onChange}
              name="truckPlate"
              type="text"
              maxLength={INPUT_CHARACTER_LIMITS.PLATES}
              label={t('document:truckPlates')}
            />
            <GInput
              className="smaller form-input w-100"
              eClass="mt-10 mr-10"
              readOnly={disabled}
              form={form}
              errors={errors}
              onChange={onChange}
              name="trailerPlate"
              type="text"
              maxLength={INPUT_CHARACTER_LIMITS.PLATES}
              label={t('document:trailerPlates')}
            />
            <div className="mt-10 mr-10">
              <div className="d-flex row align-center">
                <GInput
                  className="smaller form-input w-100"
                  form={form}
                  errors={errors}
                  onChange={onChange}
                  name="customerReferenceNumber"
                  maxLength={INPUT_CHARACTER_LIMITS.CUSTOMER_REF_NO}
                  label={t('salesInvoice:customerReferenceNumber')}
                />
                <GHref
                  disabled={!form?.customerReferenceNumber}
                  onClick={() => addCustomerRef(form?.customerReferenceNumber)}
                  className="d-flex align-center ml-8 mt-18"
                >
                  <IconAddFilled className="btn-only-icon" />
                </GHref>
              </div>
              <div className="d-flex row mt-8">
                {customerRefs?.map((r, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <CustomerRef refNo={r} onRemoveRef={() => onRemoveRef(index)} key={index} />
                ))}
                {
                  form.shipmentItems?.map((shipment, index) => (
                    <div key={'shipmentItem' + shipment.index} className="tn-ld-tag mr-8">
                      <span className="tn-ld-tag-text">{shipment.brandName} | {shipment.modelName} | {shipment.plateNumber}</span>
                      <span onClick={() => removeCar(index)} className="tn-ld-tag-close">
                        <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
                      </span>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
          <div className="w-40">
            <div className="mb-10">
              <InputLabeledContainer
                label="Extra Information"
                form={form}
                name="extraInformation"
                errors={errors}
                onChange={onChange}
                renderInput={(props) => <TextArea {...props} />}
              />
            </div>
            {form.paymentTerm && (
              <div className={'mb-10 ' + (selectedPaymentTerm?.days !== form.paymentTerm?.days && 'color-red')}>
                {t('salesInvoice:payment_term')} :
                {form.paymentTerm?.type + ' ' + form.paymentTerm?.days + ' D'}
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        <p className="text-uppercase mb-10 ls-1">
          <strong>{t('salesInvoice:priceDescription')}</strong>
        </p>
        <div className="d-flex row mb-24">
          <div className="w-40">
            <div className="mt-10 mr-10">
              <label htmlFor="" className="form-label">  {t('salesInvoice:concept')}</label>
              <div className="mt-16">{t('salesInvoice:freightAmount')}</div>
            </div>
          </div>
          <div className="w-60 d-flex row">
            <div className="flex-1">
              <GInput
                defaultValue=""
                readOnly={disabled}
                form={form}
                errors={errors}
                onChange={onChange}
                allowNegativeValue={false}
                eClass="mt-10 mr-10"
                name="amount"
                alwaysPositive
                type="currency"
                label={t('salesInvoice:amountInEuro')}
              />
            </div>
            <div className="flex-1">
              <FieldsetContainer
                name="vatPercentage"
                form={form}
                className="mt-10 mr-10"
                disabled={disabled}
                errors={errors}
                label={t('salesInvoice:vatInPercentage')}
                onChange={onChange}
                renderInput={(rest) => (
                  <PercentageInput
                    className="form-input"
                    {...rest}
                    value={form.vatPercentage || null}
                  />
                )}
              />
            </div>
            <div className="flex-1">
              <div className="mt-10 mr-10">
                <label htmlFor="" className="form-label">  {t('salesInvoice:vatEuro')}</label>
                <CurrencyInput
                  readOnly
                  value={form?.vatAmount || ''}
                  name="vatAmount"
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="mt-10 mr-10">
                <label htmlFor="" className="form-label">  {t('salesInvoice:totalsWithVat')}</label>
                <CurrencyInput
                  readOnly
                  value={form?.totalAmount || ''}
                  name="totalAmount"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hr" />
    </>
  )
}

export default React.memo(MultipleSalesInvoiceRow)
